import { Grid, IconButton, Paper } from "@material-ui/core";
import DataSearchBar from "components/DataSearchBar";
import DataTable from "components/DataTable/DataTable";
import EmptyPlaceholder from "components/EmptyPlaceholder/EmptyPlaceholder";
import ExportButton from "components/ExportButton/ExportButton";
import useSortOptions from "hooks/useSortOptions";
import { orderBy } from "lodash";
import { useState } from "react";
import FilterService from "services/filterService";
import RankingDateFilters from "./RankingDateFilters/RankingDateFilters";
import { LotRankingListStyle } from "./style";
import CachedIcon from '@material-ui/icons/Cached';

const LotRankingList = ({ setStartDate, setEndDate, lotRanking, refetch }) => {

    const classes = LotRankingListStyle();

    const [search, setSearch] = useState();
    const [spin, setSpin] = useState(false);
    const [sortOptions, sortData] = useSortOptions();

    const siteColumns = [
        { name: "Site", key: "name" },
        { name: "Size", key: "siteSizeName" },
        { name: "Pay Hours", key: "totalHours" },
        { name: "Hours>TH", key: "totalHoursOverThreshold" },
        { name: "Rank", key: "rank" },
        { name: "Points", key: "hoursPoints" },
        { name: "Inspections Missed", key: "inspectionsMissed" },
        { name: "Points", key: "inspectionPoints" },
        { name: "Audit Points", key: "auditPoints" },
        { name: "Wash Under SLA", key: "washSlaPercentage", component: (row) => <>{`${Math.round(row?.washSlaPercentage)}%`}</> },
        { name: "Points", key: "washPoints" },
        { name: "1:1s", key: "oneOnOneCount" },
        { name: "Points", key: "oneOnOnePoints" },
        { name: "Tasks", key: "lotTasks", component: (row) => <>{`${Math.round(row?.lotTasks)}%`}</> },
        { name: "Points", key: "taskPoints" },
        { name: "Total Points", key: "totalPoints" },
    ];

    const roundPoint = (point) => {
        return Math.floor(point * 100) / 100;
    }

    let lots = FilterService.filter([], search, lotRanking?.lotScores ?? [], []);
    lots = lots?.map(lot => ({
        ...lot,
        hoursPoints: roundPoint(lot.hoursPoints),
        totalPoints: roundPoint(lot.totalPoints),
        washPoints: roundPoint(lot.washPoints),
        auditPoints: roundPoint(lot.auditPoints),
        oneOnOnePoints: roundPoint(lot.oneOnOnePoints),
    }))

    const mapExportData = row => {
        const detailsInfo = {};
        siteColumns?.map(col => {
            detailsInfo[col.name] = row?.[col.key]
        });
        return detailsInfo;
    };

    const reloadData = () => {
        setSpin(true);
        setTimeout(() => {
            setSpin(false);
        }, 1000);
        refetch();
        return false;
    }

    return (

        <Paper className={classes.wrapper} elevation={1}>
            <RankingDateFilters setStartDate={setStartDate} setEndDate={setEndDate} />
            <Grid justifyContent="space-between" container className={classes.searchWrapper}>
                <Grid item xs={10}>
                    <DataSearchBar
                        onSearch={(val) => setSearch(val)} searchVal={search}
                    />
                </Grid>
                <Grid item>
                    <ExportButton label='Export' fileLabel="Export" data={lots} mapExportData={mapExportData} />
                </Grid>

                <Grid item>
                    <IconButton onClick={reloadData} size={"small"} variant="outlined" >
                        <CachedIcon
                            className={`${classes.icon} ${spin ? classes.spin : classes.refresh}`}
                            spin={spin} />
                    </IconButton>
                </Grid>
            </Grid>
            {!!lots?.length ?
                <DataTable
                    baselineColumnWidth={100}
                    columns={siteColumns}
                    rowIdentifier='id'
                    rows={orderBy(
                        lots ?? [],
                        sortOptions.columnToSort ?? 'rank',
                        sortOptions.sortDirection
                    )}
                    onSort={sortData}
                    sortDirection={sortOptions.sortDirection}
                    columnToSort={sortOptions.columnToSort}
                /> : <EmptyPlaceholder text="No Data" />}
        </Paper>
    )
}

export default LotRankingList;